(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tb-rewards-launcher"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('TBRewardsConfig');
  if (!config) return;
  const chatRoots = new WeakSet();
  const enhance = () => {
    const chatShell = document.querySelector('shopify-chat');
    const outerRoot = chatShell?.shadowRoot;
    if (outerRoot && !chatRoots.has(outerRoot)) { chatRoots.add(outerRoot); observer.observe(outerRoot, { childList: true, subtree: true }); }
    const chatRoot = outerRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    if (chatRoot && !chatRoot.getElementById('TBChatMobileStyle')) {
      const style = document.createElement('style');
      style.id = 'TBChatMobileStyle';
      style.textContent = '.activator-nudge{position:fixed!important;right:20px!important;bottom:20px!important;margin:0!important}@media(max-width:749px){.activator-nudge{position:fixed!important;right:12px!important;bottom:calc(12px + env(safe-area-inset-bottom,0px))!important;margin:0!important}.activator{box-sizing:border-box!important;width:44px!important;height:44px!important;min-width:44px!important;min-height:44px!important;padding:10px!important;border-radius:8px!important;background:#1d1b1b!important;color:#f2e6b3!important;border:1px solid #f2e6b3!important;display:flex!important;align-items:center!important;justify-content:center!important}.activator__label{display:none!important}.activator__icon{display:flex!important;width:22px!important;height:22px!important;align-items:center;justify-content:center}}';
      chatRoot.append(style);
    }

    const banner = document.querySelector('.yotpo-widget-loyalty-floater-widget .yotpo-banner-layout');
    if (banner && !banner.querySelector('.tb-rewards-native-label')) {
      const label = document.createElement('span');
      label.className = 'tb-rewards-native-label';
      const brand = document.createElement('small');
      brand.textContent = config.dataset.brand;
      const action = document.createElement('strong');
      action.textContent = config.dataset.action;
      label.append(brand, action);
      banner.prepend(label);
    }
    const headline = document.querySelector('.yotpo-widget-loyalty-floater-widget .yotpo-drawer-logged-out-headline-text');
    if (headline && config.dataset.headline && headline.textContent !== config.dataset.headline) {
      headline.textContent = config.dataset.headline;
    }
    const drawer = document.getElementById('yotpo-drawer-layout');
    if (drawer && !drawer.querySelector('.tb-rewards-native-help')) {
      const help = document.createElement('div');
      help.className = 'tb-rewards-native-help';
      const text = document.createElement('p');
      text.textContent = config.dataset.help;
      const link = document.createElement('a');
      link.href = config.dataset.url;
      link.textContent = config.dataset.guide;
      help.append(text, link);
      drawer.append(help);
    }
  };
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; enhance(); });
  });
  observer.observe(document.body, { childList: true, subtree: true });
  enhance();
  document.addEventListener('click', event => {
    const action = event.target.closest('[data-tb-open-rewards]');
    if (!action) return;
    const banner = document.querySelector('.yotpo-widget-loyalty-floater-widget .yotpo-banner-layout');
    if (!banner) return;
    event.preventDefault();
    if (banner.getAttribute('aria-expanded') !== 'true') banner.click();
    banner.focus();
  });
})();
  } catch(e) { console.error(e); }
})();

})();
